import { Stack, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TableView, { useTable, IColumn } from 'packages/ui/Table'
import ScrollTable from 'components/global/CUK/ScrollTable'
import EmptyScreen from 'packages/ui/EmptyScreen'
import { useSort } from './store'

const COLUMNS_CONFIG: IColumn[] = [
  {
    name: 'type',
    header: {
      label: ctx => ctx.t('voip.cdr.status_label')
    },
    value: ({ type }, ctx) => {
      return type === 'in' ? (
        <Tooltip title={ctx?.t('voip.cdr.status_in')}>
          <i className={'fa-solid fa-arrow-down-to-line'} />
        </Tooltip>
      ) : type === 'out' ? (
        <Tooltip title={ctx?.t('voip.cdr.status_out')}>
          <i className="fa-solid fa-arrow-up-from-line"></i>
        </Tooltip>
      ) : (
        <Tooltip title={ctx?.t('voip.cdr.status_in_out')}>
          <i className="fa-solid fa-retweet"></i>
        </Tooltip>
      )
    },
    sortable: true
  },
  {
    name: 'calling_number',
    header: {
      label: ctx => ctx.t('voip.cdr.calling_number')
    },
    value: ({ calling_number }) => calling_number as string || '-',
    sortable: true
  },
  {
    name: 'called_number',
    header: {
      label: ctx => ctx.t('voip.cdr.called_number')
    },
    value: ({ called_number }) => called_number as string || '-',
    sortable: true
  },
  {
    name: 'start_date',
    header: {
      label: ctx => ctx.t('voip.cdr.start_date')
    },
    value: ({ start_date }, ctx) =>
      start_date
        ? ctx?.t('voip.datetime', {
          date: new Date(start_date as string).toLocaleDateString(),
          time: new Date(start_date as string).toLocaleTimeString()
        })
        : '-',
    sortable: true
  },
  {
    name: 'end_date',
    header: {
      label: ctx => ctx.t('voip.cdr.end_date')
    },
    value: ({ end_date }, ctx) =>
      end_date
        ? ctx?.t('voip.datetime', {
          date: new Date(end_date as string).toLocaleDateString(),
          time: new Date(end_date as string).toLocaleTimeString()
        })
        : '-',
    sortable: true
  },
  {
    name: 'duration_in_second',
    header: {
      label: ctx => ctx.t('voip.cdr.duration')
    },
    value: ({ duration }) => duration as string,
    sortable: true
  },
  {
    name: 'waiting_duration_in_second',
    header: {
      label: ctx => ctx.t('voip.cdr.waiting_duration')
    },
    value: ({ waiting_duration }) => waiting_duration as string,
    sortable: true
  },
  {
    name: 'recipient',
    header: {
      label: ctx => ctx.t('voip.cdr.recipient')
    },
    value: ({recipient}) => recipient as string || '-',
    sortable: true
  },
  {
    name: 'transferred_to',
    header: {
      label: ctx => ctx.t('voip.cdr.transferred_to')
    },
    value: ({transferred_to}) => transferred_to as string || '-',
    sortable: true
  },
  {
    name: 'owner_name',
    header: {
      label: ctx => ctx.t('voip.cdr.owner_name')
    },
    value: ({owner_name}) => owner_name as string || '-'
  }
]

const Table = ({
  loading,
  cdrs,
  fetchNextPage,
  shouldFetchNextPage,
  onPageReset,
}) => {
  const { t } = useTranslation()
  const [sort, setSort] = useSort()

  const apiTable = useTable({
    rowKey: 'phone_short',
    rowIsOnError: (item) => {
      return Boolean(!item.answer_date)
    },
    items: cdrs,
    loading,
    columns: COLUMNS_CONFIG
  })

  if (!loading && (!cdrs || cdrs.length === 0)) {
    return (
      <Stack 
        sx={{
          height: 'calc(100cqh - 132px)',
          border: '1px dashed #D7DAEA',
          borderRadius: '24px',
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <EmptyScreen icon={'phone-volume'} variant="compact">
          {t('voip.phone_numbers.no_items')}
        </EmptyScreen>
      </Stack>
    )
  }

  return (
    <Stack sx={{ height: 'calc(100cqh - 132px)' }}>
      <ScrollTable
        fetchNextPage={fetchNextPage}
        shouldFetchNextPage={shouldFetchNextPage}
      >
        <TableView
          apiTable={apiTable}
          view={'card'}
          sort={{
            ...sort,
            onChange: name => {
              setSort(name)
              onPageReset()
            }
          }}
          noItemsMessage={t('voip.phone_numbers.no_items')}
        />
      </ScrollTable>
    </Stack>
  )
}

export default Table